import { defineMobileFormWindow } from "@app/overlay";
import {
    StockKanbanSupplyContentForm,
    type StockKanbanSupplyContentFormProps,
} from "./components/StockKanbanSupplyContentForm/StockKanbanSupplyContentForm";

/** Реестр overlay-окон карточки контейнера КАНБАН. */
export const stockKanbanSupplyCardWindows = {
    content: defineMobileFormWindow<StockKanbanSupplyContentFormProps>({
        key: "stock.kanbanSupply.content",
        title: "Комплектование партии",
        component: StockKanbanSupplyContentForm,
    }),
};
